module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst invoiceMeta = model.invoiceMeta || {}\n%><table class=\"invoice-legal\">\n<tbody>\n<tr>\n<td class=\"info\">Wir bedanken uns herzlich für Ihren Auftrag!<br>Zahlung prompt nach erhalt der Rechnung ohne Abzug.<br>Bei Überweisung bitte Rechnungsnummer angeben!</td>\n<td class=\"vat-sums\">\n<table align=\"right\">\n<tbody>\n<tr>\n<td class=\"title\">Brutto</td>\n<td class=\"title\">Netto</td>\n<td class=\"title\">MWSt - Satz</td>\n<td class=\"title\">MWSt in €</td>\n</tr>\n<%\nfor (const vat_v in invoiceMeta.sumVat) {\n%>\t\t\t\t        <tr>\n<td class=\"vat-gross\"><%= utils.number.format(invoiceMeta.sumVat[vat_v].gross || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n<td class=\"vat-net\"><%= utils.number.format(invoiceMeta.sumVat[vat_v].net || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n<td class=\"vat-val\"><%= utils.number.format(invoiceMeta.sumVat[vat_v].vat, {\nsuffix: ' %',\ndecimals: 1,\n}, 'float').formatted %></td>\n<td class=\"vat-sum\"><%= utils.number.format(invoiceMeta.sumVat[vat_v].vatV || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n</tr>\n<%                  }\n%>\t\t\t\t        <tr>\n<td class=\"vat-gross bold\"><%= utils.number.format(invoiceMeta.sumGross || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n<td class=\"vat-net bold\"><%= utils.number.format(invoiceMeta.sumNet || 0, {\nsuffix: ' €',\ndecimals: 2,\n}, 'float').formatted %></td>\n<td colspan=\"2\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>"
  , __filename = "components/templates/core/documents/invoice/invoiceLegal.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const invoiceMeta = model.invoiceMeta || {}

    ; __line = 3
    ; __append("<table class=\"invoice-legal\">\n<tbody>\n<tr>\n<td class=\"info\">Wir bedanken uns herzlich für Ihren Auftrag!<br>Zahlung prompt nach erhalt der Rechnung ohne Abzug.<br>Bei Überweisung bitte Rechnungsnummer angeben!</td>\n<td class=\"vat-sums\">\n<table align=\"right\">\n<tbody>\n<tr>\n<td class=\"title\">Brutto</td>\n<td class=\"title\">Netto</td>\n<td class=\"title\">MWSt - Satz</td>\n<td class=\"title\">MWSt in €</td>\n</tr>\n")
    ; __line = 16
    ; 
for (const vat_v in invoiceMeta.sumVat) {

    ; __line = 18
    ; __append("				        <tr>\n<td class=\"vat-gross\">")
    ; __line = 19
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumVat[vat_v].gross || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 22
    ; __append("</td>\n<td class=\"vat-net\">")
    ; __line = 23
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumVat[vat_v].net || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 26
    ; __append("</td>\n<td class=\"vat-val\">")
    ; __line = 27
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumVat[vat_v].vat, {
suffix: ' %',
decimals: 1,
}, 'float').formatted ))
    ; __line = 30
    ; __append("</td>\n<td class=\"vat-sum\">")
    ; __line = 31
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumVat[vat_v].vatV || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 34
    ; __append("</td>\n</tr>\n")
    ; __line = 36
    ;                   }

    ; __line = 37
    ; __append("				        <tr>\n<td class=\"vat-gross bold\">")
    ; __line = 38
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumGross || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 41
    ; __append("</td>\n<td class=\"vat-net bold\">")
    ; __line = 42
    ; __append(escapeFn( utils.number.format(invoiceMeta.sumNet || 0, {
suffix: ' €',
decimals: 2,
}, 'float').formatted ))
    ; __line = 45
    ; __append("</td>\n<td colspan=\"2\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>")
    ; __line = 53
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/invoice/invoiceLegal.ejs

}